import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;
    .ant-table-content {
        overflow-x: auto;
    }
    .ant-table {
        min-width: 600px;
    }
    @media (max-width: 768px) {
        .ant-table {
            min-width: 100%;
        }
    }
    & > div > div > div > div > div > table > tbody > tr > td > span:before {
        content: "";
    }

    @media screen and (max-width: 640px) {
        & > div > div > div > div > div > table {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-thead {
            display: none;
        }
        & > div > div > div > div > div > table > .ant-table-tbody {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-tbody > .ant-table-row {
            outline: 1px solid #f0f0f0;
            margin: 16px 8px;
            display: flex;
            flex-direction: column;
            border-radius: 12px;
            background: #fff;
            box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.06);
        }
        &
            > div
            > div
            > div
            > div
            > div
            > table
            > .ant-table-tbody
            > .ant-table-row
            > .ant-table-cell {
            border-bottom: 1px solid #f0f0f0;
            padding: 6px 16px !important;
            width: 100%;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span:before {
            content: attr(data-label);
            font-weight: bold;
            padding-right: 5px;
        }
    }
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;

export const ExpandedTableContainer = styled(Table)`
    .ant-table-thead > tr > th {
        background: #fafafa;
        font-weight: 600;
    }
    .expanded-cell {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .expanded-cell:before {
        display: none;
    }
    .ant-table {
        min-width: 640px;
    }
    .ant-table-content {
        overflow-x: auto;
    }
    @media (max-width: 640px) {
        .ant-table {
            min-width: 100%;
        }
        .ant-table-thead {
            display: none;
        }
        .ant-table-row {
            display: flex;
            flex-direction: column;
            border: 1px solid #f0f0f0;
            border-radius: 10px;
            margin: 16px 8px;
            overflow: hidden;
        }
        .ant-table-cell {
            border-bottom: 1px solid #f5f5f5;
            width: 100%;
            padding: 10px 16px;
        }
        .ant-table-cell:last-child {
            border-bottom: none;
        }
        .expanded-cell {
            display: grid;
            grid-template-columns: 110px 1fr;
            gap: 8px;
        }
        .expanded-cell:before {
            content: attr(data-label);
            font-weight: 600;
            color: #666;
            display: block;
        }
    }
`;

export const StyledEquipmentDetail = styled.div`
    padding: 16px;
    background: #f9f9f9;
`;

export const EquipmentDetailItem = styled.div`
    padding: 8px 12px;
    margin: 4px 0;
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-left: 3px solid #1890ff;

    &:hover {
        background: #f5f5f5;
    }
`;

export const EquipmentDetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .label {
        font-weight: 500;
        color: #666;
        margin-right: 8px;
    }

    .value {
        font-weight: 600;
        color: #333;
    }
`;
